import React, { ReactElement, useContext } from "react"
import { Link as RouterLink } from "react-router-dom"
import {
	Typography,
	Container,
	Button,
	Grid,
	Box,
	Avatar,
} from "@material-ui/core"
import { makeStyles } from "@material-ui/core/styles"
import { PrivateRoutes } from "../util/routes/routes"
import { PublicNavbar } from "../components/Navbar"
import { NewClientDialog } from "../content/dialog"
import { ClientContext } from "../state/client"
import Spacer from "../components/Spacer"

const useHomepageStyles = makeStyles((theme) => ({
	container: {
		paddingTop: theme.spacing(5),
		paddingBottom: theme.spacing(5),
	},
	grid: {
		marginTop: theme.spacing(8),
	},
	buttonBox: {
		marginTop: theme.spacing(5),
		display: "flex",
		justifyContent: "center",
		"& .MuiButton-root + .MuiButton-root": {
			marginLeft: theme.spacing(1),
		},
	},
	embed: {
		minHeight: "300px",
		border: "none",
	},
	containerIndigo: {
		backgroundColor: "#e8eaf6", // indigo50
		padding: theme.spacing(5),
		marginTop: theme.spacing(8),
	},
	containerGrey: {
		backgroundColor: "#f5f5f5",
		padding: theme.spacing(2),
		marginTop: theme.spacing(3),
	},
	contentText: {
		margin: theme.spacing(2, 0),
		width: "100%",
	},
	alignJustifyContent: {
		display: "flex",
		flexDirection: "column",
		flexWrap: "nowrap",
		justifyContent: "center",
		alignItems: "center",
		alignContent: "center",
		margin: theme.spacing(2, 0),
	},
	orange: {
		color: theme.palette.getContrastText("#ff9800"),
		backgroundColor: "#ff9800",
		width: theme.spacing(7),
		height: theme.spacing(7),
		marginTop: theme.spacing(2),
		fontSize: "1.8rem",
	},
	green: {
		color: theme.palette.getContrastText("#43a047"),
		backgroundColor: "#43a047",
		width: theme.spacing(7),
		height: theme.spacing(7),
		marginTop: theme.spacing(2),
		fontSize: "1.8rem",
	},
	blue: {
		color: theme.palette.getContrastText("#0091ea"),
		backgroundColor: "#0091ea",
		width: theme.spacing(7),
		height: theme.spacing(7),
		marginTop: theme.spacing(2),
		fontSize: "1.8rem",
	},
	MainHeading: {
		paddingTop: theme.spacing(2),
		paddingBottom: theme.spacing(1),
		fontSize: "2.2rem",
	},
	SectionTitle: {
		paddingTop: theme.spacing(1),
		fontSize: "1.8rem",
	},
}))

const Homepage = (): ReactElement => {
	const {
		state: { clients },
	} = useContext(ClientContext)
	const styles = useHomepageStyles()

	const hasClients = (): boolean => clients.length > 0

	return (
		<>
			<PublicNavbar hasClients={hasClients()} />
			<Box role="main">
				<Container className={styles.container}>
					<Typography
						align="center"
						component="h1"
						className={styles.MainHeading}
					>
						Cash Flow Change Management
					</Typography>
					<Typography align="center" component="p" variant="h5">
						Upravljanje realizacijom projekata na bazi upravljanja izmenama u
						novčanom toku
					</Typography>
				</Container>
				<Container
					maxWidth={false}
					component="div"
					className={styles.containerGrey}
				>
					<Container component="div" maxWidth="lg">
						<Grid container spacing={3}>
							<Grid item xs={12} sm={4} className={styles.alignJustifyContent}>
								<Avatar className={styles.orange}>1</Avatar>
								<Typography
									component="h2"
									variant="h5"
									className={styles.SectionTitle}
								>
									Planirani cash-flow
								</Typography>
								<Typography
									variant="body1"
									component="p"
									className={styles.contentText}
									align="center"
								>
									Planirajte troškove i prilive (provera održivosti projekta)
								</Typography>
							</Grid>
							<Grid item xs={12} sm={4} className={styles.alignJustifyContent}>
								<Avatar className={styles.green}>2</Avatar>
								<Typography
									component="h2"
									variant="h5"
									className={styles.SectionTitle}
								>
									Ugovoreni cash-flow
								</Typography>
								<Typography
									variant="body1"
									component="p"
									className={styles.contentText}
									align="center"
								>
									Evidentirajte ugovore (dinamike realizacije i plaćanja)
								</Typography>
							</Grid>
							<Grid item xs={12} sm={4} className={styles.alignJustifyContent}>
								<Avatar className={styles.blue}>3</Avatar>
								<Typography
									component="h2"
									variant="h5"
									className={styles.SectionTitle}
								>
									Izvedeni cash-flow
								</Typography>
								<Typography
									variant="body1"
									component="p"
									className={styles.contentText}
									align="center"
								>
									Upravljajte realizacijom projekta (mesečne
									korekcijecash-flow-a)
								</Typography>
							</Grid>
						</Grid>
					</Container>
				</Container>
				<Spacer space={5} />
				<Container>
					<Grid container spacing={3}>
						<Grid item xs={12} sm={8}>
							<Typography className={styles.contentText} />
						</Grid>
					</Grid>
				</Container>
				<Container>
					<Box className={styles.buttonBox}>
						{hasClients() ? (
							<Button
								color="primary"
								variant="contained"
								component={RouterLink}
								to={PrivateRoutes.ClientList}
								size="large"
							>
								Demo
							</Button>
						) : (
							<NewClientDialog triggerText="Demo" />
						)}
						{/* <ImportClient /> */}
					</Box>
					<Spacer space={5} />
				</Container>
			</Box>
		</>
	)
}

export default Homepage
